import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link } from 'base-ui'

import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import { experimentAccessorIsMarketplace } from '../../../experiments/model/experimentAccessor'
import { useGlobalConfigContext } from '../../../global-config'
import { useSellerModalContext } from '../../../seller'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'

export const ProductSearchResultItemMarketplaceSeller: FC = () => {
  const {
    algoliaRecord: { best_offer, offers_count, upid },
  } = useProductSearchResultItemContext()

  const globalConfig = useGlobalConfigContext()

  const { showSellerModal } = useSellerModalContext()

  const { experiments } = useExperimentsContext()

  const isMarketplaceEnabled = experimentAccessorIsMarketplace(
    experiments,
    globalConfig.tenant,
  )

  if (
    !best_offer?.seller ||
    best_offer.type !== 'MIRAKL' ||
    !isMarketplaceEnabled ||
    offers_count !== 1
  ) {
    return null
  }

  const sellerId = best_offer.seller.id

  return (
    <div className="z-10 inline-flex items-start justify-start gap-2.5 rounded-lg bg-light-primary-medium px-3.5 pb-3 pt-3.5">
      <div className="shrink grow basis-0">
        <span className="text-xs font-medium text-dark-primary-max">
          <FormattedMessage id="message.soldAndShipped.partner" />{' '}
        </span>
        <span className="text-xs font-medium text-dark-brand underline">
          <Link
            data-clientside-hook={`open-seller-modal--${sellerId}`}
            data-qa-id="seller-name"
            onClick={() => {
              showSellerModal({
                productUpid: upid,
                sellerId,
              })
            }}
            slots={{ root: 'button' }}
            type="button"
          >
            {best_offer.seller.name}
          </Link>
        </span>
      </div>
    </div>
  )
}
